import { render, staticRenderFns } from "./HospitalList.vue?vue&type=template&id=2f7ba246&"
import script from "./HospitalList.vue?vue&type=script&lang=ts&"
export * from "./HospitalList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports